<template>
  <div class="bg-secondary-3">
    <div class="py-1 px-4 rounded">
      <div class="row mt-4">
        <div class="col-9 d-flex">
          <i class="fas fa-undo text-orange mr-2 mt-1"></i>
          <p class="callout-sub-section-title">
            Reemplazar Documento de Discusión
          </p>
        </div>
      </div>
      <validation-observer ref="formValidator">
        <div class="row">
          <div class="col-12">
            <ValidationProvider
              v-slot="{ errors, validate }"
              mode="lazy"
              rules="required"
              :custom-messages="{
                required: 'Este campo es requerido.'
              }"
            >
              <CustomTextArea
                label="Razón de Reemplazo:"
                v-model="reason"
                regular-label
                :rows="3"
                :maxlength="500"
                show-char-count
                :count-classes="['d-block text-right', 'small-counter']"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="validate"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Archivo"
              rules="required"
            >
              <CustomFileInput
                ref="attachedDocument"
                label="Documento:"
                v-model="document"
                required
                :accept="'pdf'"
                display-style="normal"
                label-position="left"
                :error="errors[0]"
                custom-error-msg="Favor
              anejar documento."
                :on-download="downloadFile"
              />
            </ValidationProvider>
          </div>
          <div class="col-8 mt-3 mb-3 pt-0 text-right">
            <ActionButton
              class="m-1"
              text="Cancelar"
              variant="outline-danger"
              i="fas fa-times-circle"
              @click="close"
            />
            <ActionButton
              class="m-1 mr-0"
              text="Guardar"
              variant="success"
              i="fas fa-save"
              @click="save"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import Callout from "custom-callout";
import CustomTextArea from "CustomTextArea";
import CustomFileInput from "CustomFileInput";
import academicProgressCalendarServices from "@/services/pei/peiAcademicProgressCalendar";
import mixAlert from "@/mixin/alert.mixin";
import documentsService from "@/services/documents";
export default {
  name: "ReplaceDiscussionDocument",
  components: {
    ActionButton,
    Callout,
    CustomTextArea,
    CustomFileInput
  },
  mixins: [mixAlert],
  data: () => ({
    reason: null,
    document: null
  }),
  props: {
    item: {
      type: Object,
      default: {},
      require: true
    }
  },
  methods: {
    downloadFile(attachmentId) {
      documentsService.downloadFromServer(attachmentId);
    },
    async save() {
      var validationResult = await this.$refs.formValidator.validate();
      if (validationResult) {
        try {
          const formData = new FormData();
          formData.append("Document", this.document);
          formData.append("AcademicProgressId", this.item.academicProgressId);
          formData.append("Reason", this.reason);
          await academicProgressCalendarServices.replaceDiscussionDocument(
            formData
          );
          this.ShowToast(
            "",
            "El documento ha sido reemplazado de manera exitosa.",
            "success"
          );
          this.document = null;
          this.reason = null;
          this.$emit("saved");
          this.$forceUpdate();
        } catch (err) {
          this.ShowToast("", "Error al crear la solicitud.", "error");
        }
      }
    },
    close() {
      this.document = null;
      this.reason = null;
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  font-weight: normal !important;
}
</style>
